<template>
  <!-- } 20230704 추가 -->
  <div
    v-for="(content, i) in contents"
    v-bind:key="(content, i)"
    class="each-pattern-taps"
    :class="{ 
      active: patternContentIndex === i,
      lock: content.customer === false || (content.customer === undefined && content.groupContents?.some((groupContent) => !groupContent.customer))
    }"
    @click="selectTab(i)"
    v-show="!([constants.CONSTANT_MENU_PATTERN_PRODUCT_CODE].includes(parentMenuCode) && i === 1)" 
  >
    <!-- 20230612 div.each-pattern-tap-wrap 추가 및 탭버튼 CSS 넘버링 추가 { -->
    <div class="each-pattern-tap-wrap">
      <div class="each-pattern-tap">
        <div v-if="content.groupContents">
          <!-- span 태그 div 로 변경 -->
          <div class="tap-title">
            <!-- div.tap-title 추가 -->
            <span v-if="content.groupContents[0].groupName && content.groupContents[0].groupName !== ''">
              {{ getGroupName(content.groupContents[0]) }}
            </span>
            <template v-else>
              <span v-for="(groupContent, groupIndex) in content.groupContents"
                :key="groupContent.code">
                <span v-if="groupIndex !== 0">/</span>
                {{ getName(groupContent) }}
              </span>
            </template>
          </div>
          <span v-if="[constants.CONSTANT_MENU_SWITCHING_CODE].includes(parentMenuCode) && content.groupContents[0].groupType === 1 && i === patternContents.length-1">
            <p v-for="(groupContent, groupIndex) in content.groupContents"
              :key="(groupContent, groupIndex)"
              class="option-name"
              :title="
                patternSelected[i]?.[groupIndex]?.list.length > 0 && (groupIndex === 2 || patternSelected[patternContents.length-2]?.[0]?.list.length > 0)
                  ? patternSelected[i]?.[groupIndex]?.list
                      .map((l) => getName(l))
                      .join(', ')
                  : $t('label.not_selected')
              "
              :class="{
                bold: (
                  [2, 3, 4, 5].includes(groupIndex)
                  || (patternSelected[i]?.[groupIndex]?.list[0]?.name && patternSelected[patternContents.length-2]?.[0]?.list.length > 0)
                ),
                slim: [constants.CONSTANT_MENU_CL_Diagnosis_CODE].includes(parentMenuCode)
              }"
              v-show="
                [2, 3, 4, 5].includes(groupIndex)
                || (groupIndex === 0 && patternSelected[patternContents.length-2]?.[0]?.list[0]?.code === constants.CONSTANT_SWITCHING_MONTH_PERIOD_CODES)
                || (groupIndex === 1 && patternSelected[patternContents.length-2]?.[0]?.list[0]?.code === constants.CONSTANT_SWITCHING_QUARTER_PERIOD_CODES)
                || (groupIndex === 0 && (patternSelected[patternContents.length-2]?.[0]?.list.length ?? 0) === 0)
              "
            >
              <template v-if="[constants.CONSTANT_MENU_SWITCHING_CODE].includes(parentMenuCode) && i === patternContents.length-1 && [0, 1].includes(groupIndex)">
                {{ $t("label.comparisonPeriod") }}
                :
                {{
                  patternSelected[i]?.[groupIndex]?.list.length > 0 && patternSelected[patternContents.length-2]?.[0]?.list.length > 0
                    ? patternSelected[i]?.[groupIndex]?.list
                        .map((l) => getName(l))
                        .join(', ')
                    : $t('label.not_selected')
                }}
              </template>
              <template v-else>
                {{ getName(groupContent) }}
                :
                {{
                  patternSelected[i]?.[groupIndex]?.list.length > 0
                    ? patternSelected[i]?.[groupIndex]?.list
                        .map((l) => getName(l))
                        .join(', ')
                    : $t('label.not_selected')
                }}
              </template>
            </p>
          </span>
          <span v-else-if="content.groupContents[0].groupType === 1">
            <p v-for="(groupContent, groupIndex) in content.groupContents"
              :key="(groupContent, groupIndex)"
              class="option-name"
              :title="
                patternSelected[i]?.[groupIndex]?.list.length > 0
                  ? patternSelected[i]?.[groupIndex]?.list
                      .map((l) => getName(l))
                      .join(', ')
                  : $t('label.not_selected')
              "
              :class="{
                bold: (patternSelected[i]?.[groupIndex]?.list[0]?.name),
                slim: [constants.CONSTANT_MENU_CL_Diagnosis_CODE].includes(parentMenuCode)
              }"
            >
              {{ getName(groupContent) }}
              :
              {{
                patternSelected[i]?.[groupIndex]?.list.length > 0
                  ? patternSelected[i]?.[groupIndex]?.list
                      .map((l) => getName(l))
                      .join(', ')
                  : $t('label.not_selected')
              }}
            </p>
          </span>
          <span v-else>
            <p
              class="option-name"
              :title="
                patternSelected[i]?.[0]?.list.length > 0
                  ? patternSelected[i]?.[0]?.list
                      .map((l) => getName(l))
                      .join(', ')
                  : $t('label.not_selected')
              "
              :class="{
                bold: patternSelected[i]?.[0]?.list[0]?.name,
                slim: [constants.CONSTANT_MENU_CL_Diagnosis_CODE].includes(parentMenuCode)
              }"
            >
              {{
                patternSelected[i]?.[0]?.list.length > 0
                  ? patternSelected[i]?.[0]?.list
                      .map((l) => getName(l))
                      .join(", ")
                  : $t("label.not_selected")
              }}
            </p>
          </span>
        </div>
        <div v-else>
          <div class="tap-title"> {{ getName(content) }} </div>
          <p v-if="[constants.CONSTANT_MENU_SWITCHING_CODE].includes(parentMenuCode) && patternSelected[i] && patternSelected[i].length > 0 && patternSelected[i][0].name"
            class="option-name"
            :title="
              patternSelected[i]?.[0]?.list?.length > 0
                ? getName(patternSelected[i][0]) + ' - ' +  patternSelected[i]?.[0]?.list
                    .map((l) => getName(l))
                    .join(', ')
                : $t('label.not_selected')
            "
            :class="{
              bold: patternSelected[i]?.[0]?.list[0]?.name,
              slim: [constants.CONSTANT_MENU_CL_Diagnosis_CODE].includes(parentMenuCode)
            }"
          >
            {{
              patternSelected[i]?.[0]?.list?.length > 0
                ? getName(patternSelected[i][0]) + ' - ' + patternSelected[i]?.[0]?.list
                      .map((l) => getName(l))
                      .join(", ")
                : $t("label.not_selected")
            }}
          </p>
          <p v-else
            class="option-name"
            :title="
              patternSelected[i]?.[0]?.list?.length > 0
                ? patternSelected[i]?.[0]?.list
                    .map((l) => getName(l))
                    .join(', ')
                : $t('label.not_selected')
            "
            :class="{ 
              bold: patternSelected[i]?.[0]?.list[0]?.name,
              slim: [constants.CONSTANT_MENU_CL_Diagnosis_CODE].includes(parentMenuCode)
              }"
          >
            {{
              patternSelected[i]?.[0]?.list?.length > 0
                ? patternSelected[i]?.[0]?.list
                      .map((l) => getName(l))
                      .join(", ")
                : $t("label.not_selected")
            }}
          </p>
        </div>
      </div>
    </div>
    <!-- } 20230612 div.each-pattern-tap-wrap 추가 및 탭버튼 CSS 넘버링 추가 -->
  </div>
</template>

<script>
import AlertDialog from "@/components/AlertDialog.vue";
import { defineComponent } from "vue";
import { storeToRefs } from "pinia";
import { useI18n } from "vue-i18n";
import { useContentsStore } from "@/store/contents";
import constants from "@/data/constants.js";
import PatternReport from "@/components/pattern/PatternReport.vue";

export default defineComponent({
  name: "AsideContentList",
  emits: ['selectTab'],
  components: {
    PatternReport,
    AlertDialog,
  },
  props: {
    parentMenuCode: {
      type: String,
      required: true,
    },
    patternContents: {
      type: [Array, Object],
      required: true
    },
  },
  setup(props, { emit }) {
    const { t, locale } = useI18n();

    const contentsStore = useContentsStore();
    const {
      contents,
      patternSelected,
      patternContentIndex,
    } = storeToRefs(contentsStore);

    const selectTab = async (index) => {
      emit('selectTab', index);
    };

    const getName = (content) => {
      return locale.value == 'en'
        ? content.englishName
        : content.name;
    };

    const getGroupName = (content) => {
      return locale.value == 'en'
        ? content.englishGroupName
        : content.groupName;
    };

    return {
      constants,

      contents,
      patternSelected,
      patternContentIndex,

      selectTab,

      getName,
      getGroupName,
    };
  },
});
</script>

<style scoped>
.each-pattern-tap-wrap {
  counter-reset: list-number;
}
.each-pattern-taps {
  position: relative;
  width: 100%;
  flex-direction: column;
  padding: 18px 16px;
  cursor: pointer;
  border: var(--border-line);
  border-radius: var(--border-radius);
  counter-increment: list-number;
  background-color: #f4f4f4;
  transition: all 0.3s;
}

.each-pattern-taps::before {
  position: absolute;
  top: 18px;
  left: 16px;
  content: counter(list-number);
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #fff;
  background-color: #d3d3d3;
  border-radius: 50%;
}

.each-pattern-taps ~ .each-pattern-taps {
  margin-top: 5px;
}

.each-pattern-taps.active {
  background-color: #fff;
  border-color: var(--primary-color);
}

.each-pattern-taps.active::before {
  background-color: var(--primary-color);
  color: #fff;
}

.tap-title {
  padding-left: 30px;
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
}

.option-name {
  position: relative;
  margin-top: 12px;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.4;
  color: var(--font-sec-color);
  padding-left: 30px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.slim {
  margin-top: 10px;
}

.slim + .slim{
  margin-top: 6px;
}

.option-name::before {
  position: absolute;
  left: 9px;
  top: 7px;
  content: "";
  width: 5px;
  height: 5px;
  background-color: #d6d6d6;
  border-radius: 50%;
}

.bold {
  font-weight: 700;
}

.lock {

  .tap-title {
    display: flex;
  }

  .tap-title::after {
    display: inline-block;
    width: 20px;
    height: 20px;
    margin-left: 6px; /*before, after는 좌우 마진 가질 수 있다.*/
    content: '';
    background-image: url("@/assets/img/lock.png");
  }

  &.active {
    .tap-title::after {
      background-image: url("@/assets/img/lock_active.png");
    }
  }
}
</style>
